import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { MatButtonModule } from '@angular/material/button';
import { AngularFireModule } from '@angular/fire/compat';

import { GlobalHttpInterceptorProvider } from '@app/interceptor/http/http-interceptor.provider';
import { DateSelectorModule } from '@shared/components/date-selector/date-selector.module';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { SidebarLayoutComponent } from './layout/sidebar-layout/sidebar-layout.component';
import { BreadcrumbModule } from '@shared/components/breadcrumb/breadcrumb.module';
import { NavbarLayoutModule } from './layout/navbar-layout/navbar-layout.module';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { NpsDialogModule } from '@shared/dialogs/nps-dialog/nps-dialog.module';
import { AvatarModule } from '@shared/components/avatar/avatar.module';
import { BrandModule } from '@shared/components/brand/brand.module';
import { CoreModule } from '@app/core.module';
import { ExternalAccoutingConfirmationModule } from '@shared/dialogs/external-accouting-confirmation/external-accouting-confirmation.module';
import { ConfirmationDialogModule } from '@shared/dialogs/confirmation-dialog/confirmation-dialog.module';
import { SnowModule } from '@shared/components/snow/snow.module';

// const user = User.fromLocalStorage();
// const url = `${environment.messagingBaseUrl}/api/v1/notifications/ws/subscribe?username=${user.username || user.email}`;

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    ContentLayoutComponent,
    SidebarLayoutComponent,
    // NavbarLayoutComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NpsDialogModule,

    HttpClientModule,

    // core & shared
    CoreModule,
    // SharedModule,
    ExternalAccoutingConfirmationModule,

    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),

    //
    NavbarLayoutModule,
    MatButtonModule,

    SnowModule,

    // Global Components
    AvatarModule,
    BrandModule,
    BreadcrumbModule,

    // Firebase Notifications
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),

    HttpClientJsonpModule,
    DateSelectorModule,

    ConfirmationDialogModule,

  ],
  providers: [
    GlobalHttpInterceptorProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
